import React from 'react';
import { FormLabel } from './FormLabel';

interface SelectProps<T extends string> {
  label: string;
  value: T;
  onChange: (value: T) => void;
  options: readonly T[] | T[];
  error?: string;
  required?: boolean;
  tooltip?: string;
  disabled?: boolean;
  placeholder?: string;
}

export const Select = <T extends string>({
  label,
  value,
  onChange,
  options,
  error,
  required = false,
  tooltip,
  disabled = false,
  placeholder = "Select one..."
}: SelectProps<T>) => {
  return (
    <div className="flex flex-col gap-1">
      {label && (
        <FormLabel label={label} required={required} tooltip={tooltip} />
      )}
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as T)}
        disabled={disabled}
        className={`rounded-md border ${
          error ? 'border-red-300' : 'border-gray-300'
        } px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
          disabled ? 'bg-gray-100' : ''
        }`}
      >
        <option value="" disabled hidden>
          {placeholder}
        </option>
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
};